module.exports = __webpack_public_path__ + "media/delfin_k.d9566636.mp3";